<template>
  <ed-modal
    :show="show"
    :title="title"
    primary-button="Save"
    secondary-button="Cancel"
    type="medium"
    @close="onClose"
    @validate="onSave"
    :validation="validation"
    :closeOnEsc="true"
  >
    <div class="content" slot="body">
      <ed-form class="col-md-12 no-pad" :submit-visible="false">
        <div class="row">
          <br />
          <div class="col-md-10">
            <ed-input
              field-label="Supplier name"
              required="required"
              placeholder="Enter the name of the supplier"
              v-model="formData.supplierName"
              :error="doDisplaySupplierNameError"
              :helptip-header=" doDisplaySupplierNameError && 'Error' || ''"
              :helptip-body="doDisplaySupplierNameError && 'Please fill in supplier name' || ''"
              @change="doDisplaySupplierNameError = false"
              :disabled="disableControls"
              name='supplier_name'
            />
          </div>
        </div>
        <div class="row">
          <div class="col-md-5">
            <ed-input
              field-label="Supplier ID"
              placeholder="Enter the supplier's ID"
              v-model="formData.supplierId"
              :disabled="disableControls"
              name='supplier_id'/>
          </div>
          <div class="col-md-5">
            <ed-input
              field-label="Supplier VAT/GST ID"
              placeholder="Enter the supplier's VAT/GST ID"
              v-model="formData.supplierVATGSTId"
              name='supplier_vat'
            />
          </div>
        </div>
        <div class="row">
          <div class="col-md-5">
            <ed-input
              field-label="Supplier Contact Name"
              required="required"
              v-model="formData.supplierContact"
              :error="doDisplaySupplierContactError"
              :helptip-header=" doDisplaySupplierContactError &&  'Error' || ''"
              :helptip-body="doDisplaySupplierContactError && 'Please fill in supplier contact' || ''"
              @change="doDisplaySupplierContactError = false"
              :disabled="disableControls"
              placeholder="Enter the name of the supplier's representative"
              name='supplier_contact_name'
            />
          </div>
          <div class="col-md-5">
            <ed-input
              field-label="Email Address"
              required="required"
              placeholder="Enter the supplier's email address"
              v-model="formData.emailAddress"
              :error="doDisplayEmailError"
              :helptip-header=" doDisplayEmailError &&  'Error' || ''"
              :helptip-body="doDisplayEmailError && 'Please fill in email' || ''"
              @change="emailChanged"
              name='supplier_email'
            />
          </div>
        </div>

        <div class="row">
          <h5 class="col-md-12 section-title">Supplier Information</h5>
        </div>

        <div class="row">
          <div class="col-md-5">
            <ed-input
              field-label="Phone"
              placeholder="Enter the supplier's phone number"
              v-model="formData.phone"
              :error="doDisplayPhoneError"
              :helptip-header="doDisplayPhoneError &&  'Error' || ''"
              :helptip-body="doDisplayPhoneError && 'Please fill in phone' || ''"
              @change="doDisplayPhoneError = false"
              :disabled="disableControls"
              name='supplier_phone'
            />
          </div>
        </div>

        <div class="row">
          <div class="col-md-5">
            <ed-input
              field-label="Address 1"
              placeholder="Enter the supplier's first address"
              v-model="formData.address1"
              :disabled="disableControls"
              name='supplier_address1'/>
          </div>
          <div class="col-md-5">
            <ed-input
              field-label="Address 2"
              placeholder="Enter the supplier's second address"
              v-model="formData.address2"
              :disabled="disableControls"
              name='supplier_address2'/>
          </div>
        </div>
        <div class="row">
          <div class="col-md-5">
            <ed-input
              field-label="City"
              placeholder="Enter the supplier's city"
              v-model="formData.city"
              :disabled="disableControls"
              name='supplier_city'/>
          </div>
          <div class="col-md-5">
            <ed-select
              v-if="isUS()"
              field-label="State"
              placeholder="Select a state"
              :options="USstates"
              v-model="formData.state"
              @open="fetchUSStatesOnOpen"
              @keyup="fetchUSStates"
              @close="restoreUSStates"
              label="StateName"
              track-by="StateID"
              :disabled="disableControls"
              name='us_states'
            />
            <ed-select
              v-if="isCanada()"
              field-label="State/Region"
              placeholder="Select a region"
              :options="canadaStates"
              v-model="formData.canadaState"
              @open="fetchCanadaStatesOnOpen"
              @keyup="fetchCanadaStates"
              @close="restoreCanadaStates"
              label="StateName"
              :disabled="disableControls"
              name='canada_states'
            />
            <ed-input
              v-if="!formData.country || !isCanada() && !isUS()"
              field-label="State/Region"
              placeholder="Select a region"
              v-model="formData.region"
              :disabled="disableControls"
              name='state_region'/>
          </div>
        </div>

        <div class="row">
          <div class="col-md-5">
            <ed-input
              field-label="Postal/Zip Code"
              placeholder="Enter the supplier's zip"
              v-model="formData.postalCode"
              :disabled="disableControls"
              name='supplier_postal_zip'/>
          </div>
          <div class="col-md-5">
            <ed-select
              field-label="Country"
              placeholder="Select a country..."
              :options="countries"
              v-model="formData.country"
              label="CountryName"
              track-by="CountryID"
              :openEndpoint='api.$.profile.getAllCountries'
              @select="countrySelected($event)"
              @open="fetchCountriesOnOpen"
              @keyup="fetchCountries"
              @close="restoreCountries"
              :error="doDisplayCountryError"
              :helptip-header="doDisplayCountryError && 'Error' || ''"
              :helptip-body="doDisplayCountryError && 'Please select a country' || ''"
              :disabled="disableControls"
              name='supplier_country'
            />
          </div>
        </div>
      </ed-form>
    </div>
  </ed-modal>
</template>
<script>
/* eslint spec-file: 0 */

import { Eved, EventBus } from '@/event-bus'

export default {
  name: 'AddSupplier', /* mandatory field */
  props: {
    model: Object,
    invoiceId: Number,
    eventHub: Object,
    operation: String
  },

  data: function() {
    if (this.operation === 'edit') {
      return {
        formData: {
          supplierName: this.model.supplier.companyName,
          supplierId: this.model.supplier.id,
          supplierVATGSTId: this.model.supplier.vatGstCode,
          supplierContact: this.model.supplier.contactName,
          emailAddress: this.model.supplier.email,
          phone: this.model.supplier.phone,
          address1: this.model.supplier.address.address1,
          address2: this.model.supplier.address.address2,
          city: this.model.supplier.address.city,
          postalCode: this.model.supplier.address.zipCode,
          country: this.model.supplier.address.country,
          state: {
            StateID: 0,
            StateName: this.model.supplier.address.state
          },
          canadaState: {
            StateID: 0,
            StateName: this.model.supplier.address.state
          },
          region: this.model.supplier.address.region
        },

        USstates: [],
        canadaStates: [],

        countries: [],
        show: true,

        validation: true,
        title: 'Edit Supplier',
        doDisplaySupplierNameError: false,
        doDisplaySupplierContactError: false,
        doDisplayEmailError: false,
        doDisplayPhoneError: false,
        doDisplayCountryError: false,
        counter: 0,
        disableControls: false
      }
    } else {
      return {
        formData: {
          supplierName: '',
          supplierId: '',
          supplierVATGSTId: '',
          supplierContact: '',
          emailAddress: '',
          phone: '',
          address1: '',
          address2: '',
          city: '',
          postalCode: '',
          originalCountryName: '',
          country: '',
          state: {
            StateID: 0,
            StateName: ''
          },
          canadaState: {
            StateID: 0,
            StateName: ''
          },
          region: ''
        },

        USstates: [],
        USoriginalStates: [],

        canadaStates: [],
        originalCanadaStates: [],

        countries: [],
        originalCountries: [],
        show: true,

        validation: true,
        title: 'Add New Supplier',
        doDisplaySupplierNameError: false,
        doDisplaySupplierContactError: false,
        doDisplayEmailError: false,
        doDisplayPhoneError: false,
        doDisplayCountryError: false,
        counter: 0,
        disableControls: false
      }
    }
  },

  methods: {
    fetchCountriesOnOpen() {
      if (this.countries.length) {
      } else {
        this.api.forms.post(
          this.api.$.profile.getAllCountries,
          {
            q: ''
          }
          ).then(r => {
            if (r && r.data && r.data.Data) {
              this.countries = r.data.Data
              this.originalCountries = r.data.Data
            }
          }
        ).catch(e => console.warn(e))
      }
    },

    fetchCountries(value) {
      this.counter || this.api.forms.post(
        this.api.$.profile.getAllCountries,
        {
          q: value || ''
        }
      ).then(r => {
        this.counter = 0
        if (r && r.data && r.data.Data) {
          this.countries = r.data.Data
        }
      }
      ).catch(e => {
        console.warn(e)
        this.counter = 0
      })
      this.counter = 1
    },

    restoreCountries() {
      if (this.counter === 0) {
        this.countries = utils.copy(this.originalCountries)
      }
    },

    isUS() {
      return this.formData.country && this.formData.country.CountryName === 'United States'
    },
    GetStatesUSURL() {
      return this.api.$.profile.getAllStates
    },

    isCanada() {
      return this.formData.country && this.formData.country.CountryName === 'Canada'
    },
    GetStatesCanadaURL() {
      return this.api.$.profile.getCanadaStates
    },

    // Fetch States on OPEN
    fetchUSStatesOnOpen() {
      var url = this.GetStatesUSURL()
      this.fetchStatesOnOpen(this.USstates, url)
    },
    fetchCanadaStatesOnOpen() {
      var url = this.GetStatesCanadaURL()
      this.fetchStatesOnOpen(this.canadaStates, url)
    },
    fetchStatesOnOpen(states, url) {
      if (states.length && (this.isCanada() || this.isUS())) {
      } else {
        this.api.forms.post(
          url,
          {
            q: ''
          }
          ).then(r => {
            if (r && r.data && r.data.Data) {
              this.mapStatesDataOnOpen(r.data.Data)
            }
          }
        ).catch(e => console.warn(e))
      }
    },
    mapStatesDataOnOpen(data) {
      if (this.isUS()) {
        this.USstates = this.USoriginalStates = data
      } else {
        this.canadaStates = this.originalCanadaStates = data
      }
    },

    // Fetch States on search text
    fetchUSStates(value) {
      var url = this.GetStatesUSURL()
      this.fetchStates(value, url)
    },
    fetchCanadaStates(value) {
      var url = this.GetStatesCanadaURL()
      this.fetchStates(value, url)
    },
    fetchStates(value, url) {
      this.counter || this.api.forms.post(
        url,
        {
          q: value || ''
        }
      ).then(r => {
        this.counter = 0
        if (r && r.data && r.data.Data) {
          this.mapStatesDataOnFetch(r.data.Data)
        }
      }
      ).catch(e => {
        console.warn(e)
        this.counter = 0
      })
      this.counter = 1
    },
    mapStatesDataOnFetch(data) {
      if (this.isUS()) {
        this.USstates = data
      } else {
        this.canadaStates = data
      }
    },

    // Restore States
    restoreUSStates() {
      this.restoreStates(this.USstates, this.USoriginalStates)
    },
    restoreCanadaStates() {
      this.restoreStates(this.canadaStates, this.originalCanadaStates)
    },
    restoreStates(states, originalStates) {
      if (this.counter === 0) {
        this.states = utils.copy(originalStates)
      }
    },

    emailChanged() {
      this.doDisplayEmailError = false

      var supplierInfo = {
        EmailAddress: this.formData.emailAddress,
        InvoiceId: this.getInvoiceId
      }

      this.api.forms.post(
        this.api.$.invoice.i2p.getSupplierFromAddSupplierButton,
        {
          supplier: supplierInfo
        }
        ).then(r => {
          if (r && r.data && r.data.Data) {
            var response = JSON.parse(r.data.Data)
            this.populateFormData(response)
          }
        }
      ).catch(e => console.warn(e))
    },

    populateFormData(data) {
      if (data.CompanyName !== null && data.OutSideNewSupplier !== 'Yes') {
        this.formData = {
          supplierName: data.CompanyName,
          supplierId: data.SupplierIDCode,
          supplierVATGSTId: data.SupplierVatGstId,
          supplierContact: data.SupplierContact,
          emailAddress: data.SupplierContactEmail,
          phone: data.Phone,
          address1: data.Address,
          address2: data.Address2,
          city: data.City,
          postalCode: data.Zip,
          originalCountryName: data.CountryName,
          country: {
            'CountryID': data.CountryID,
            'CountryName': data.CountryName
          },
          state: {
            StateID: data.isCanada === 'False' && data.StateID || 0,
            StateName: data.isCanada === 'False' && data.State || ''
          },
          canadaState: {
            StateID: data.isCanada === 'True' && data.StateID || 0,
            StateName: data.isCanada === 'True' && data.State || ''
          },
          region: data.Region
        }
        this.disableControls = true
      } else {
        this.disableControls = false
      }
    },

    onClose() {
      this.eventHub.$emit('onCloseAddSupplier', {})
      this.show = false
    },

    onSave() {
      if (!this.isValid()) return

      var supplierInfoVM = this.getSupplierInfoVM()
      this.getSupplier(supplierInfoVM)

      this.show = false
    },

    getSupplier(supplierInfoVM) {
      this.api.forms.post(
        this.api.$.invoice.i2p.getSupplierFromAddSupplierButton,
        {
          supplier: supplierInfoVM
        }
        ).then(r => {
          if (r && r.data && r.data.Data) {
            var response = JSON.parse(r.data.Data)
            this.populateFormData(response)

            var info = {
              SupplierInfoVM: this.getSupplierInfoVM(),
              VendorId: response.VendorId || response.VendorWithVendorsID || 0,
              VendorUserID: response.VendorUserID || 0,
              VendorVCI: response.VendorVCI || 0,
              CardInfo: JSON.parse(response.SupplierCardInfo)
            }

            EventBus.$emit(Eved.I2P.ADDED_NEW_SUPPLIER, info)
          }
        }
      ).catch(e => console.warn(e))
    },

    getSupplierInfoVM() {
      return {
        SupplierName: this.formData.supplierName,
        SupplierID: this.formData.supplierId,
        SupplierVatGstID: this.formData.supplierVATGSTId,
        SupplierContactName: this.formData.supplierContact,
        EmailAddress: this.formData.emailAddress,
        SupplierPhone: this.formData.phone,
        SupplierAddress1: this.formData.address1,
        SupplierAddress2: this.formData.address2,
        SupplierCity: this.formData.city,
        SupplierZIP: this.formData.postalCode,
        SupplierCountryID: this.formData.country.CountryID,
        CountryName: this.formData.country.CountryName,
        SupplierStateID: this.isUS() ? this.formData.state.StateID : 0,
        SupplierRegion: this.isCanada() ? this.formData.canadaState.StateName : this.formData.region,
        State: this.formData.state.StateName,
        InvoiceId: this.invoiceId
      }
    },

    isValid() {
      var result = true

      if (
        !(
          this.formData.supplierName.length &&
          this.formData.supplierName.length > 0
        )
      ) {
        this.doDisplaySupplierNameError = true
        result = false
      }

      if (
        !(
          this.formData.supplierContact &&
          this.formData.supplierContact.length &&
          this.formData.supplierContact.length > 0
        )
      ) {
        this.doDisplaySupplierContactError = true
        result = false
      }

      if (
        !(
          this.formData.emailAddress.length &&
          this.formData.emailAddress.length > 0
        )
      ) {
        this.doDisplayEmailError = true
        result = false
      } else {
        if (!this.validateEmail(this.formData.emailAddress)) {
          this.doDisplayEmailError = true
          result = false
        }
      }

      return result
    },

    validateEmail(email) {
      var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      return re.test(email)
    },

    countrySelected(e) {
      this.doDisplayCountryError = false
      this.resetState(e.CountryName)
    },

    resetState(countryName) {
      if (this.originalCountryName !== '' && this.originalCountryName !== countryName) {
        this.formData.state = {
          StateID: 0,
          StateName: ''
        }
        this.formData.canadaState = {
          StateID: 0,
          StateName: ''
        }
        this.formData.region = ''
      } else {
        this.originalCountryName = countryName
      }
    }
  }
}
</script>

<style scoped lang='scss'>
@import "~@/assets/sass/_variables.scss";

.section-title {
  @include soft-font;
  font-size: $font-size-base-lg;
  font-weight: $font-weight-normal;
  @include theme {
    color: v(border);
  }
  margin-bottom: 7px;
}

</style>



// WEBPACK FOOTER //
// src/components/_modules/I2P/dialogs/AddEditSupplier.vue